import { Injectable } from '@angular/core';
import { TemplateModel } from '../template/template.model';
import { DocumentModel } from './document.model';
import { DocumentControlContentLanguageLabelModel } from './document-control-content-language-label.model';

@Injectable()
export class DocumentEditService {
    MouseDownOnText = false;

    constructor() {}

    TemplateToDocument(Template: TemplateModel, Document: DocumentModel, initialTemplate: TemplateModel) {
        Template.PlaceHolderCollection.forEach((placeHolder) => {
            placeHolder.ControlCollection.forEach((templateControl) => {
                const initialControl = initialTemplate.FindPlaceHolderControlById(templateControl.Id);
                // for each control content should be created different DocumentControlContentLanguageLabel
                templateControl.Contents.forEach((templateControlContent) => {
                    let documentControlContent = templateControlContent.DocumentControlContent;
                    const value = JSON.stringify(templateControlContent.Value);
                    if (!documentControlContent) {
                        // find the same element from initial template and compare their contents
                        // we should not add not changed block
                        initialControl.Contents.forEach((initialContent) => {
                            if (initialContent.ContentLanguageId == templateControlContent.ContentLanguageId) {
                                if (JSON.stringify(initialContent.Value) !== value) {
                                    // if previous save was with error we can already have data in Document.DocumentControlContents

                                    const existingDocumentControlContent = Document.DocumentControlContents.find(
                                        (cc) =>
                                            cc.PlaceHolderControlId === templateControl.Id &&
                                            cc.ContentLanguageId === templateControlContent.ContentLanguageId &&
                                            cc.ControlType === templateControlContent.ControlType,
                                    );

                                    if (!existingDocumentControlContent) {
                                        documentControlContent = new DocumentControlContentLanguageLabelModel({
                                            PlaceHolderControlId: templateControl.Id,
                                            ContentLanguageId: templateControlContent.ContentLanguageId,
                                            ControlType: templateControlContent.ControlType,
                                        });
                                        Document.DocumentControlContents.push(documentControlContent);
                                    }
                                }
                            }
                        });
                    }
                    if (documentControlContent) documentControlContent.Value = value;
                });
            });
        });
    }
}
